





































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import NavigationItem from '@/shared/classes/layouts/navigation-item'
import __ from '@/shared/helpers/__'
import Can from '@/shared/components/Can.vue'
import can from '@/shared/helpers/can.helper'
import { GlobalActions } from '@/shared/store/global/global.actions'
import { NavigationState } from '@/shared/store/global/global.state'
import { GlobalGetters } from '@/shared/store/global/global.getters'
import roleCan from "@/shared/helpers/role-can.helper";

@Component({
  components: {
    Can
  },
  methods: {
    __,
    can,
    roleCan
  }
})
export default class Navigation extends Vue {
  @Prop() items!: NavigationItem[]
  activeItem: NavigationItem | null = null
  activeChildItem: NavigationItem | null = null
  isHover: boolean = false

  created() {
    let found: NavigationItem | null = null
    let childFound: NavigationItem | null = null

    this.items.forEach((item: NavigationItem) => {
      if (found) return
      if ((this.$router.currentRoute.name as string).startsWith(item.route)) return found = item
      item.subItems.forEach((subItem: NavigationItem) => {
        if (found) return
        if ((this.$router.currentRoute.name as string).startsWith(subItem.route)) {

          found = item
          childFound = subItem
        }
      })
    })

    if (found) this.activeItem = found
    if (this.activeItem && childFound) {
      this.activeItem.open = true
      this.activeChildItem = childFound
    }
  }

  navigate(navigationItem: NavigationItem, childNavigationItem?: NavigationItem): void {
    if (this.$vuetify.breakpoint.smAndDown) { // Close navigation on mobile after click
        this.$store.dispatch(GlobalActions.setNavigation, NavigationState.default)
    }

    this.activeItem = navigationItem
    this.activeChildItem = childNavigationItem ? childNavigationItem : null
    this.$router.push({ name: childNavigationItem ? childNavigationItem.route : navigationItem.route }).catch(() => {})
  }

  openNavigation(item: NavigationItem) {
    if (item.childOpen) {
      const foundSubItem: NavigationItem | any = item.subItems.find((subItem: NavigationItem) => subItem.route === item.childOpen)
      this.navigate(item, foundSubItem)
    }
    if (this.$vuetify.breakpoint.smAndDown || this.isHover) return
    this.$store.dispatch(GlobalActions.setNavigation, NavigationState.default)
  }

  hover(value: boolean): void {
    this.isHover = value
    if (! this.isMinimized && ! value) this.closeNavigationItems()
  }

  get isMinimized(): boolean {
    if (this.$vuetify.breakpoint.mdAndDown) return true

    return this.$store.getters[GlobalGetters.getNavigation] === NavigationState.default
  }

  get getClass(): string {
    const navigationState = this.$store.getters[GlobalGetters.getNavigation]

    if (navigationState === NavigationState.minimized) {
      return 'nav-minimized'
    }

    return 'nav-default'
  }

  @Watch('$store.state.global.navigation') closeNavigationItems() {
    if (this.$vuetify.breakpoint.smAndDown) return
    if (this.$store.getters[GlobalGetters.getNavigation] === NavigationState.minimized) {
      this.items.forEach((item: NavigationItem) => item.open = false)
    }
  }
}
